<template>
    <div class="price-filter">
        <v-range-slider
                v-model="range"
                hide-details
                class="align-center"
                color="orange"
                :label="componentLabel"
                :max="max"
                :min="min"
                @end="valueChange"
        >
        </v-range-slider>
        <v-row>
            <v-col cols="6">
                <v-text-field
                        :value="range[0]"
                        class="mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 60px"
                        @change="textPriceChange($event, 0)"
                ></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-text-field
                        :value="range[1]"
                        class="mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 60px"
                        @change="textPriceChange($event, 1)"
                ></v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import FiltersGeneral from '../../../app-front/mixins/FiltersGeneral';

    export default {
        name: "FilterPrice",
        props:['label', 'filterKey', 'resetFilter'],
        mixins: [FiltersGeneral],
        data() {
            return {
                range: [
                    this.min,
                    this.max
                ],
                min: 0,
                max: 10000,
                storeFilterKey: this.filterKey
            }
        },
        computed: {
            componentLabel() {
                return this.label || this.$t('price')
            },
            maxPriceName() {
                return this.$store.state.filters.general.maxPrice.systemName;
            },
            minPriceName() {
                return this.$store.state.filters.general.minPrice.systemName;
            },
            storeFilterMin() {
                const name = this.$store.state.filters.general.minPrice.systemName;
                return this.$store.state.filters[this.filterKey][name] || this.min;
            },
            storeFilterMax() {
                const name = this.$store.state.filters.general.maxPrice.systemName;

                return this.$store.state.filters[this.filterKey][name] || this.max;
            },
        },
        methods: {
            textPriceChange(e, key) {
                this.$set(this.range, key, e);
                this.valueChange();
            },
            valueChange() {
                const minPrice = this.range[0];
                const maxPrice = this.range[1];
                this.priceHandle(minPrice, this.minPriceName);
                this.priceHandle(maxPrice, this.maxPriceName);
                this.setStoreFiltersToUrl();
                this.$emit('value-change');
            },
            priceHandle(price, name) {
                const commitData = {
                    key: this.filterKey
                };

                if(price === this.min || price === this.max) {
                    commitData.name = name;
                    this.$store.commit('deleteFilter', commitData);
                } else {
                    commitData.name = name;
                    commitData.value = price;
                    this.$store.commit('setFilter', commitData);
                }
            }
        },
        created() {
            this.range[1] = this.storeFilterMax;
            this.range[0] = this.storeFilterMin;
        },
        watch: {
            resetFilter() {
                this.range[0] = this.min;
                this.range[1] = this.max;
            },
            storeFilterMax() {
                this.range[1] = this.storeFilterMax;
            },
            storeFilterMin() {
                this.range[0] = this.storeFilterMin;
            }
        }
    }
</script>

<style scoped>

</style>
